// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_enum-bug-keys.js
// module id = 148
// module chunks = 39